const SvgWhatsapp: React.FC<{ className?: string; height?: number; width?: number }> = ({
  className = "",
  height = 24,
  width = 24,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={`${className}`}
    viewBox="0 0 24 24"
    width={width}
    height={height}
    fill="currentColor"
    stroke="none"
  >
    <path d="M20.52 3.48A11.8 11.8 0 0 0 12.04 0C5.4 0 .1 5.3.1 11.94c0 2.1.55 4.15 1.6 5.96L0 24l6.3-1.64a12 12 0 0 0 5.73 1.46h.01c6.63 0 11.93-5.3 11.93-11.94 0-3.18-1.24-6.17-3.45-8.4zM12.04 21.3c-1.8 0-3.56-.48-5.1-1.38l-.36-.21-3.74.97 1-3.64-.24-.38a9.9 9.9 0 0 1-1.52-5.26c0-5.47 4.46-9.93 9.96-9.93 2.66 0 5.16 1.04 7.04 2.93a9.9 9.9 0 0 1 2.92 7.04c0 5.47-4.46 9.93-9.96 9.93zm5.48-7.45c-.3-.15-1.77-.87-2.04-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.47-.88-.78-1.47-1.74-1.64-2.04-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.48-.5-.67-.5-.17 0-.37-.02-.57-.02-.2 0-.52.07-.8.37-.27.3-1.05 1.03-1.05 2.5 0 1.47 1.08 2.9 1.23 3.1.15.2 2.12 3.24 5.14 4.54.72.31 1.28.5 1.72.64.72.23 1.38.2 1.9.12.58-.08 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.07-.12-.27-.2-.57-.35z" />
  </svg>
);

export default SvgWhatsapp;
